
export enum LogLevel {
	DEBUG = 'DEBUG',
	ERROR = 'ERROR',
	FATAL = 'FATAL',
	INFO = 'INFO',
	WARN = 'WARN'}

